import { httpTokenCommon } from "../helper/http-common";

const getSelectedCompanyCode = () => {
	try {
		return String(localStorage.getItem("Company_Code") || "").trim();
	} catch {
		return "";
	}
};

const withCompanyCode = (inputData = {}) => ({
	...inputData,
	company_Code: getSelectedCompanyCode(),
});

const withCompanyCodeQuery = (url) => {
	const separator = url.includes("?") ? "&" : "?";
	return `${url}${separator}company_Code=${encodeURIComponent(getSelectedCompanyCode())}`;
};

class KycService {
	getKycTileCountsAPI(inputData) {
		return httpTokenCommon.post("kyc/TileCounts", withCompanyCode(inputData));
	}

	getKycGroupCompanyListAPI(inputData) {
		return httpTokenCommon.post("kyc/GroupCompany/List", withCompanyCode(inputData));
	}

	getKycCompanyListAPI(inputData) {
		return httpTokenCommon.post("kyc/Company/List", withCompanyCode(inputData));
	}

	getKycMaterialMasterListAPI(inputData) {
		return httpTokenCommon.post("kyc/MaterialMaster/List", withCompanyCode(inputData));
	}

	getKycDesignMasterListAPI(inputData) {
		return httpTokenCommon.post("kyc/DesingMasterListing/List", withCompanyCode(inputData));
	}

	getKycDesignDetailsListAPI(inputData) {
		return httpTokenCommon.post("kyc/DesingDetails/List", withCompanyCode(inputData));
	}

	getKycQuotationMasterListAPI(inputData) {
		return httpTokenCommon.post("kyc/QuotationMasterListing/List", withCompanyCode(inputData));
	}

	getKycOrderMasterListAPI(inputData) {
		return httpTokenCommon.post("kyc/OrderMasterListing/List", withCompanyCode(inputData));
	}

	getKycOrderDetailListAPI(inputData) {
		return httpTokenCommon.post("kyc/OrderDetailListing/List", withCompanyCode(inputData));
	}

	getKycQuotationDetailListAPI(inputData) {
		return httpTokenCommon.post("kyc/QuotationDetailListing/List", withCompanyCode(inputData));
	}

	getQuotationContactDataByIdAPI(inputData) {
		return httpTokenCommon.post("kyc/Quotation/ContactDataById", withCompanyCode(inputData));
	}

	getKycMaterialCharacteristicsListAPI(inputData) {
		return httpTokenCommon.post("kyc/MaterialCharacteristics/List", withCompanyCode(inputData));
	}

	getKycQualityIssueMasterListAPI(inputData) {
		return httpTokenCommon.post("kyc/QualityIssueMasterListing/List", withCompanyCode(inputData));
	}

	getPrimaryContactDataBySapCodeAPI(sapCode) {
		return httpTokenCommon.post(
			withCompanyCodeQuery(
				`kyc/GetPrimaryContactDataBySapCode?SAPCode=${encodeURIComponent(sapCode)}`
			)
		);
	}

	getPartnerFunctionByCompanyGuidAPI(crmGuid) {
		return httpTokenCommon.post(
			withCompanyCodeQuery(
				`kyc/GetPartnerFunctionByCompanyGUID?CrmGuid=${encodeURIComponent(crmGuid)}`
			)
		);
	}

	getKycGlobalFiltersAPI() {
		return httpTokenCommon.get("kyc/GlobalFilters", {
			params: { company_Code: getSelectedCompanyCode() },
		});
	}

	getKycMapGroupCompanyAPI(inputData) {
		return httpTokenCommon.post("kyc/Map/GroupCompany", withCompanyCode(inputData));
	}

	getKycMapCompanyAPI(inputData) {
		return httpTokenCommon.post("kyc/Map/Company", withCompanyCode(inputData));
	}

	getKycMapCountryAPI(inputData) {
		return httpTokenCommon.post("kyc/Map/Country", withCompanyCode(inputData));
	}

	getKycMapStateAPI(inputData) {
		return httpTokenCommon.post("kyc/Map/State", withCompanyCode(inputData));
	}

	getKycMapDistrictCityAPI(inputData) {
		return httpTokenCommon.post("kyc/Map/DistrictCity", withCompanyCode(inputData));
	}

	getKycMapFormattedAddressAPI(inputData) {
		return httpTokenCommon.post("kyc/Map/FormattedAddress", withCompanyCode(inputData));
	}

	getKycMapRelationTypeAPI(inputData) {
		return httpTokenCommon.post("kyc/Map/RelationType", withCompanyCode(inputData));
	}

	getKycMapCompanyLocationListAPI(inputData) {
		return httpTokenCommon.post("kyc/Map/CompanyLocation/List", withCompanyCode(inputData));
	}

	getKycMapYearlyInvoiceSummaryAPI(inputData) {
		return httpTokenCommon.post("kyc/Map/TenPillars/YearlyInvoiceSummary", withCompanyCode(inputData));
	}
}

const kycService = new KycService();
export default kycService;
